import { useEffect } from 'react';
import { redirectToSignIn, redirectToSignUp } from '../utils';

/**
 * Satellite-app replacements for Clerk's <RedirectToSignUp /> / <RedirectToSignIn />.
 *
 * Clerk's built-ins bounce to town-square auth URLs without forwarding localStorage /
 * query attribution, so server-side `account_created` fires with empty UTMs. These
 * helpers use `redirectToSignUp` / `redirectToSignIn`, which append attribution onto
 * both the town-square auth URL and the post-auth return URL.
 */
export function AttributionRedirectToSignUp({ redirectPath }: { redirectPath?: string }) {
  useEffect(() => {
    redirectToSignUp(redirectPath);
  }, [redirectPath]);

  return null;
}

export function AttributionRedirectToSignIn({ redirectPath }: { redirectPath?: string }) {
  useEffect(() => {
    redirectToSignIn(redirectPath);
  }, [redirectPath]);

  return null;
}
